// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';

type Context = 'entering' | 'entered' | 'exiting' | 'exited';

const Transition = React.createContext<Context>('entered');
/**
 * Allow the redux state managers to distribute the transition state to each consumer
 */
export default Transition;
